(function(){
function init(root){
  if(!root||root.dataset.ready)return;root.dataset.ready='true';
  root.style.setProperty('--tcc-font',getComputedStyle(root).fontFamily);
  root.querySelectorAll('.story-main,.story-detail,.story-third,.workshop-new-photo,.featured-photo,.photo').forEach(function(el){if(!el.querySelector('img'))el.hidden=true;});
  root.querySelectorAll('[data-rail]').forEach(function(rail){
    var sec=rail.closest('section')||root,f=rail.classList.contains('featured-rail')?.8:.75;
    var p=sec.querySelector('[data-rail-prev]'),n=sec.querySelector('[data-rail-next]');
    if(p)p.onclick=function(){rail.scrollBy({left:-rail.clientWidth*f,behavior:'smooth'})};
    if(n)n.onclick=function(){rail.scrollBy({left:rail.clientWidth*f,behavior:'smooth'})};
  });
  root.querySelectorAll('.story-step').forEach(function(step){observer.observe(step)});
  parallax();
}
var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){e.target.classList.toggle('is-active',e.isIntersecting&&e.intersectionRatio>.3)})},{threshold:[0,.3,.6]});
var scheduled=false;
function parallax(){
  scheduled=false;if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  document.querySelectorAll('.tcc-home .story-step').forEach(function(step){
    var box=step.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;
    var travel=Math.max(1,box.height-innerHeight),progress=Math.max(0,Math.min(1,-box.top/travel)),panel=step.querySelector('.story-scene');
    if(!panel)return;panel.style.setProperty('--layer-main',(-35+progress*95)+'px');panel.style.setProperty('--layer-detail',(85-progress*205)+'px');panel.style.setProperty('--layer-third',(-45+progress*120)+'px');
  });
}
function initAll(){document.querySelectorAll('[data-tcc-home]').forEach(init)}
if(!window.__tccHome){
  window.__tccHome=true;
  addEventListener('scroll',function(){if(!scheduled){requestAnimationFrame(parallax);scheduled=true}},{passive:true});
  addEventListener('resize',parallax);
  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:block:select',function(e){var s=e.target.closest&&e.target.closest('.story-step');if(s)s.scrollIntoView({block:'start'})});
  document.addEventListener('DOMContentLoaded',initAll);
}
initAll();
})();
